import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_URL_PREFIX } from '../../services/basic.service';
import { ErrorHandlingService } from '../../services/error-handling.service';

@Injectable()
export class PasswordRequestService {
  constructor(private httpClient: HttpClient, private errorHandlingService: ErrorHandlingService) {}

  request(companyId: number, email: string) {
    return this.httpClient
      .post(`${API_URL_PREFIX}/${companyId}/password-request`, { email })
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }
}
